<template>
  <el-container class="content" style="display: block;">

	<el-container class="lables">

		<el-row  class="la-list" style="margin: 50px 0;">
			<el-col :span="10" class="first">

				<el-row class="lable-o-l lable-o-ls" v-for="(item,index) in lableFirst" :key="index">

          <el-row>
          	<el-col :span="12">
              <div class="lable-o" v-for="(items,indexs) in item" :key="indexs" v-if="items['z_h'] == 1" :class="{'choses':choseAF.indexOf(items.id)>-1&&items.id!=choses,'chosess':items.id==choses}"  @click="chose(items.id,1)">
              {{items.name}}
              </div>

            </el-col>
            <el-col :span="12">
              <div class="lable-o" v-for="(items,indexs) in item" :key="indexs" v-if="items['z_h'] == 2" :class="{'choses':choseAF.indexOf(items.id)>-1&&items.id!=choses,'chosess':items.id==choses}"  @click="chose(items.id,2)">
              {{items.name}}
              </div>
            </el-col>
          </el-row>
				</el-row>

			</el-col>

			<el-col :span="12" class="two" style="margin: 0 0;">
        <div class="add" @click="add(2)" style="width: 50%;margin-top: 10px;margin-left: 20%;" v-if="this.$store.getters.getRole == 'admins' || this.$store.getters.getRole == 'fenxi' || this.$store.getters.getRole == 'admin' || this.$store.getters.getRole == 'entry'">+ 添加</div>
        <el-row class="lable-o-l"   v-if="zh == 1">
          <div v-for="(item,index) in lableTwo" style="position: relative;">
            <div class="lable-two" style="float: left;width: 70%;padding: 10px 0;"  :key="item.id" @click="lableC(item.id,item.name,item.s_or_x,item.ss)">
            {{item.name}}
            </div>

          </div>

        </el-row>
				<el-row class="lable-o-l" v-if="zh == 2">
          <el-table
          :data="lableTwo"


          width='2780'
          border
          style="width: 880px;text-align: center;margin: 0;">


          <el-table-column
            width="120"
            label="兔子坐标"
             >
             <template slot-scope="scope">
                 <div  @click="changeT(1,scope.row.can.zuobiaot,scope.row.can.id)">{{scope.row.can.zuobiaot}}</div>



             </template>
          </el-table-column>
          <el-table-column
            width="50"
            label="比例"
             >
             <template slot-scope="scope">
                <div  @click="changeT(2,scope.row.can.bili,scope.row.can.id)">{{scope.row.can.bili}}</div>



             </template>
          </el-table-column>
          <el-table-column
            width="80"
            label="界面展示"
             >
             <template slot-scope="scope">
                 <div  @click="changeT(3,scope.row.can.jiemian,scope.row.can.id)">{{scope.row.can.jiemian}}</div>


             </template>
          </el-table-column>
          <el-table-column
            width="120"
            label="界面坐标"
             >
             <template slot-scope="scope">
                 <div  @click="changeT(5,scope.row.can.zuobiaoj,scope.row.can.id)">{{scope.row.can.zuobiaoj}}</div>



             </template>
          </el-table-column>
          <el-table-column
            width="80"
            label="展示推荐"
             >
             <template slot-scope="scope">
                 <div  @click="changeT(4,scope.row.can.tuijian,scope.row.can.id)">{{scope.row.can.tuijian}}</div>


             </template>
          </el-table-column>
          <el-table-column
            width="120"
            label="左上三标"
             >
             <template slot-scope="scope">
                 <div  @click="changeT(6,scope.row.can.zuoshangsan,scope.row.can.id)">{{scope.row.can.zuoshangsan}}</div>



             </template>
          </el-table-column>
          <el-table-column
            width="120"
            label="右下三标"
             >
             <template slot-scope="scope">
                 <div  @click="changeT(7,scope.row.can.youxiasan,scope.row.can.id)">{{scope.row.can.youxiasan}}</div>



             </template>
          </el-table-column>


          </el-table>
					<div v-for="(item,index) in lableTwo" style="position: relative;border:2px solid #000000;height: 150px;">
					  <div class="lable-two" style="padding: 10px 0;"  :key="item.id" @click="lableC(item.id,item.name)">
					  {{item.name}}
					  </div>
            <div>
              <div style="float: left;margin-left: 20px;"  v-for="(img,imgindex) in item.img">
                <div style="float: left;margin-left: 20px;">
                  <el-upload
                    class="avatar-uploader"

                    :action="UploadUrl1(img.id)"
                    :show-file-list="false"
                    @click.native="ceshi(img.$index,img.id)"
                    :on-success="handleAvatarSuccess1"
                    style="display: inline;">

                    <img style="width: 60px;height: 60px;"  v-if="img.img" :src="img.img" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </div>
                <div  style="float: left;padding: 10px 0;margin-left: 5px;"  :key="index" @click="delImg(img.id)">
                X
                </div>
              </div>
              <div style="float: left;margin-left: 20px;">
                <el-upload
                  class="avatar-uploader"

                  :action="UploadUrl(item.id)"
                  :show-file-list="false"
                  @click.native="ceshi(item.$index,item.id)"
                  :on-success="handleAvatarSuccess"
                  style="display: inline;">


                  <i  class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
            </div>

					</div>

				</el-row>
			</el-col>
		</el-row>

	</el-container>
  <el-dialog
    title="添加"
    :visible.sync="centerDialogVisible"
    width="30%"
    center>
    <input type="text" v-focus="picFocusStatus" class="searchT" v-model="addT"/>
    <span slot="footer" class="dialog-footer">
  	<el-button @click="centerDialogVisible = false">取 消</el-button>
  	<el-button type="primary" @click="doAdd()">确 定</el-button>
    </span>
  </el-dialog>
  <el-dialog
    title="修改"
    :visible.sync="mDialogVisible"
    width="30%"
    center>
    <input type="text" v-focus="picFocusStatus" class="searchT" v-model="addM"/>
    <span slot="footer" class="dialog-footer">
  	<el-button @click="mDialogVisible = false">取 消</el-button>
  	<el-button type="primary" @click="doAddm()">确 定</el-button>
    </span>
  </el-dialog>
  </el-container>

</template>

<script>

  export default {
    data() {
      return {
        lableFirst:[],
        lableTwo:[],
        chosesT:0,
        choses:0,
        choseAF:[],
        choseAT:[],
        centerDialogVisible:false,
        lable:[],
        zh:1,
        token:window.localStorage.getItem('token'),
        userId:window.localStorage.getItem('id'),
        url:this.$store.getters.getUrl,
        imageId:0,
        addType:0,
        addT:'',
        picFocusStatus:false,
        mt:0,
        mid:0,
        addM:'',
        mDialogVisible:false,
        imgId:0
      };
    },
	directives: {
		focus: {
		  inserted: function(el, { value }) {
			if (value) {
			  el.focus();
			}
		  }
		}
    },
    created() {
        if(!window.localStorage.getItem('id')){
              this.$router.push({ path: '/' })
            }
        this.loadData();


    },

	methods:{
    changeT(t,name,id){
      this.mt = t
      this.mid = id
      this.addM = name
      this.mDialogVisible = true
    },
    doAdd(){
    	if(this.addT == ''){
    		this.msg('内容不能为空','error')
    		return false;
    	}
    	if(this.addType == 2){
    		let p_id = this.choses;
    		const axiosInstance = this.$axios.create({
    			headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
    			withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
    		});
    		axiosInstance({
    			method:'post',
    			params:{
    				addcf:0,
    				name:this.addT,
    				p_id:p_id,
    				token:this.token,
    				userId:this.userId
    			},
    			url:'http://fencip.yoooooo.com/index.php/index/data/acAddm'
    		})
    		.then(res=>{
    			if(res.data.code == 200){
    				this.centerDialogVisible = false;
    				this.addT = '';
    				this.loadDataTwo();
    				this.addType = 0
    			}else if(res.data.code == 202){
    				this.centerDialogVisible = false;

    			}else{
    				this.centerDialogVisible = false;
    				this.addT = '';
    				alert('添加失败')
    			}

    		})
    		.catch(err=>{

    		});
    	}else{
    		const axiosInstance = this.$axios.create({
    			headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
    			withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
    		});
    		axiosInstance({
    			method:'post',
    			params:{
    				name:this.addT,
    				id:this.chosesT,
    				token:this.token,
    				userId:this.userId
    			},
    			url:'http://fencip.yoooooo.com/index.php/index/data/acChange'
    		})
    		.then(res=>{
    			if(res.data.code == 200){
    				this.centerDialogVisible = false;
    				this.loadDataTwo();
    			}else{
    				this.centerDialogVisible = false;
    				this.addT = '';
    				alert('添加失败')
    			}

    		})
    		.catch(err=>{

    		});
    	}

    },
    doAddm(){
    	if(this.addM == ''){
    		this.msg('内容不能为空','error')
    		return false;
    	}
    	const axiosInstance = this.$axios.create({
    		headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
    		withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
    	});
    	axiosInstance({
    		method:'post',
    		params:{
    			name:this.addM,
    			id:this.mid,
    			t:this.mt

    		},
    		url:'http://fencip.yoooooo.com/index.php/index/data/acChangem'
    	})
    	.then(res=>{
    		if(res.data.code == 200){
    			this.mDialogVisible = false;
    			this.loadDataTwo();
    		}else{
    			this.mDialogVisible = false;
    			this.addM = '';
    			alert('添加失败')
    		}

    	})
    	.catch(err=>{

    	});

    },
    add(type){
    	this.addType = type;
    	if(type == 2){

    		this.addT = '';
    	}
    	this.centerDialogVisible = true;
      this.picFocusStatus = true
    },
    ceshi(index,id){
      this.imageId = index
      this.imgId = id
    },
    UploadUrl(id){
      // return "http://fencip.yoooooo.com/index.php/index/data/acimgChange2?id="+id
      return "http://data3.yoooooo.com/index.php/index/data/pythonImgSave"
    },
    UploadUrl1(id){
      // return "http://fencip.yoooooo.com/index.php/index/data/acimgChange1?id="+id
      return "http://data3.yoooooo.com/index.php/index/data/pythonImgSave"
    },
    handleAvatarSuccess(res, file) {
    
      this.imgChange(this.imgId,file.response.data)
    
    },
    handleAvatarSuccess1(res, file) {
    
      this.imgChange1(this.imgId,file.response.data)
    
    },
    imgChange(id,img){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:id,
          img:img
    
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/acimgChange2New'
      })
      .then(res=>{
    
    
        this.loadDataTwo();
    
    
    
    
      })
      .catch(err=>{
    
      });
    },
    imgChange1(id,img){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:id,
          img:img
    
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/acimgChange1New'
      })
      .then(res=>{
    
    
        this.loadDataTwo();
    
    
    
    
      })
      .catch(err=>{
    
      });
    },
    delImg(id){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
      		id:id
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/delImg1'
      })
      .then(res=>{
        this.loadDataTwo();

      })
      .catch(err=>{

      });
    },
		loadData(){
			const axiosInstance = this.$axios.create({
				headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
				withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
			});
			axiosInstance({
				method:'get',
				params:{
					name:this.searchF
				},
				url:'http://fencip.yoooooo.com/index.php/index/data/acFirstimgm'
			})
			.then(res=>{
				this.lableFirst = res.data;

			})
			.catch(err=>{

			});
		},
		loadDataTwo(){
			const axiosInstance = this.$axios.create({
				headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
				withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
			});
			axiosInstance({
				method:'get',
				params:{
					name:this.searchT,
					p_id:this.choses
				},
				url:'http://fencip.yoooooo.com/index.php/index/data/acimgTwom'
			})
			.then(res=>{
				this.lableTwo = res.data;
        this.count = res.data.length
			})
			.catch(err=>{

			});
		},
		chose(id,t){
			this.choses = id;
			this.searchT = '';
      this.zh = t;
			this.loadDataTwo();

		},
		lableC(id,name){
		  if (this.$store.getters.getRole == 'admins' || this.$store.getters.getRole == 'fenxi' || this.$store.getters.getRole == 'admin'){
		    this.addT = name;
		    this.chosesT = id;
		    this.add(1);
		  }

		},

		msg(msg,type){
			this.$message({
			  message: msg,
			  type: type
			});
		}

	}


  }
</script>

<style>

	.content{
		background: #939AA0;
		width: 100%;
		height: 100%;
	}
	.centr{
		margin-top: 30%;
	}
	.centr img{
		width: 100px;
		height: 50px;
		margin-left: 35px;
	}

	.zhuyi{
		color: red;
    margin-left: 120px;
    font-size: 20px;
	}
	.butn{
		color: #F0F8FF;
		background: #FF9400;
		margin-right: 20px;
		border-radius: 5px;
		width: 50px;
	}
	.lables{
		margin-left: 5%;
		margin-right: 5%;
		background: #fff;
		padding-bottom: 35px;
	}
	.lables .la-list{
		margin-top: 50px;
		width: 100%;
		margin-left: 4%;
		margin-right: 4%;
	}
	.first{
		border: 1px solid #c6c6c6;
		height: 850px;
		overflow-y:scroll;
	}
	.first .el-row{
		margin: 20px 10% 20px 10%;
	}
	.search input{
		width: 95%;
		height: 20px;
		margin-bottom: 10px;
		margin-left: 2%;
	}
	.add{
		text-align: center;
		width: 96%;
		background: #c6c6c6;
		height: 22px;
		line-height: 22px;
		margin-left: 2%;
	}

	.lable-o{
		width: 47%;
		text-align: center;
		background: #c6c6c6;
		height: 30px;
		line-height: 30px;
		margin-bottom: 10px;
	}
	.lable-two{

		text-align: center;
		background: #c6c6c6;

		line-height: 30px;
		margin-bottom: 10px;
	}
	.choses{
		background: #f8f1da;
	}
	.chosess{
		background: #ff9400;
	}
	.right{
		float: right;
	}
	.left{
		float: left;
	}
	.two{
		border: 1px solid #c6c6c6;
		height: 850px;
		overflow-y:scroll;
	}
	.two .el-row{
		margin: 20px 10% 20px 10%;
	}
	.searchTsx{
		width: 30%;
		margin-left: 10%;
		height: 30px;
	}
  .s_or_x{
    width: 20%;
    height: 35px;
  }
	.lable-o-ls{
		border-bottom: 1px solid #c6c6c6;
	}
</style>



// WEBPACK FOOTER //
// src/components/main/acimgm.vue